import React, { useEffect, useState } from "react";
import { Image, Text, TouchableOpacity, View } from "react-native";
import Switch from "react-switch";
import { useDispatch, useSelector } from "react-redux";
import i18n from "i18next";
import { sprintf } from "sprintf-js";

import {
  getEmployee,
  getPosition,
  putModerateCash
} from "../../../redux/actions";
import { Reducers } from "../../../redux/types";
import styles from "./styles";
import "./style.css";
import Fixed from "../../Fixed";
import Card from "../../Card";
import { IMAGES } from "../../../configs";
import { copyWritings } from "../../../utils";

interface Props {
  onCancel: () => void;
  invoiceId: string;
  cashSettlement: boolean;
}

const ModerateInvoice = ({ invoiceId, onCancel, cashSettlement }: Props) => {
  const dispatch = useDispatch();

  const { position, listEmployee } = useSelector(
    (state: Reducers) => state.employee
  );
  const { moderationReference } = useSelector((state: Reducers) => state.cash);

  const copTeks = {
    employee: copyWritings("employee")
  };

  const [addModeration, setAddModeration] = useState(false);
  const [moderationBy, setModerationBy] = useState("");
  const _getDropdownData = (moderation: boolean) => {
    if (!moderation && position.length === 0 && listEmployee.length === 0) {
      dispatch(getPosition());
      dispatch(getEmployee());
    }
  };
  const [body, setBody]: any = useState({
    id: "",
    answer: "",
    position_id: "",
    employee_id: "",
    message: ""
  });

  useEffect(() => {
    if (moderationReference) {
      setBody({
        ...body,
        id: moderationReference[moderationReference.length - 1].id
      });
    }
  }, [moderationReference]);

  const _handleModerateCash = () => {
    if (moderationBy === "1") {
      setBody({ ...body, employee_id: null });
    } else {
      setBody({ ...body, position_id: null });
    }

    if (body.answer !== "1") {
      setBody({ ...body, employee_id: null, position_id: null });
    }
    dispatch(putModerateCash(body, invoiceId));
    onCancel();
  };

  const handleAddModeration = () => {
    return (
      moderationReference &&
      moderationReference.length > 0 &&
      moderationReference[moderationReference.length - 1].stage_current ===
        moderationReference[moderationReference.length - 1].stage_total
    );
  };

  return (
    <View style={{ width: "100%", height: "100%" }}>
      <View style={styles.containerContent}>
        <Text style={styles.title}>{i18n.t("moderation.yourResponse")}</Text>
        <View style={[styles.card, styles.containerDropdown]}>
          <select
            className="moderation-dropdown"
            onChange={e =>
              setBody({
                ...body,
                answer: e.target.value,
                employee_id: "",
                position_id: "",
                message: ""
              })
            }
          >
            <option selected hidden>
              {i18n.t("moderation.selectAnswer")}
            </option>
            <option value="1">{i18n.t("moderation.approve")}</option>
            <option value="2" hidden={cashSettlement}>
              {i18n.t("moderation.needToRevise")}
            </option>
            <option value="3">{i18n.t("moderation.reject")}</option>
          </select>
        </View>
        {body.answer !== "1" && body.answer !== "" ? (
          <View
            style={{
              width: "70%",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <Text style={[styles.title, { marginVertical: 15 }]}>
              {i18n.t("moderation.notes")}
            </Text>
            <textarea
              value={body.message}
              onChange={e => setBody({ ...body, message: e.target.value })}
              style={{
                minWidth: "70%",
                fontFamily: "Poppins",
                fontSize: 12,
                fontWeight: "bold",
                color: "#666666"
              }}
            />
          </View>
        ) : null}
        {body.answer === "1" && handleAddModeration() ? (
          <View style={{ marginTop: 40 }}>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Switch
                onChange={() => {
                  _getDropdownData(addModeration);
                  setAddModeration(!addModeration);
                  setModerationBy("");
                }}
                checked={addModeration}
                onColor="#50b1b1"
                onHandleColor="#fffff7"
                handleDiameter={19}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 2px rgba(0, 0, 0, 0.2)"
                height={19}
                width={34}
              />

              <Text style={styles.moderationText}>
                {" "}
                {i18n.t("moderation.addModeration")}
              </Text>
            </View>
            {addModeration ? (
              <View>
                <View
                  style={[
                    styles.card,
                    styles.containerDropdown,
                    { marginTop: 16, alignSelf: "center" }
                  ]}
                >
                  <select
                    className="moderation-dropdown"
                    onChange={e => {
                      setModerationBy(e.target.value);
                    }}
                  >
                    <option selected hidden>
                      {i18n.t("moderation.selectModerationBy")}
                    </option>
                    <option value="1">{i18n.t("moderation.position")}</option>
                    <option value="2">{copTeks.employee}</option>
                  </select>
                </View>
                {moderationBy ? (
                  <View style={{ width: "100%" }}>
                    {moderationBy === "1" ? (
                      <View
                        style={[
                          styles.card,
                          styles.containerDropdown,
                          { marginTop: 16 }
                        ]}
                      >
                        <select
                          onChange={e => {
                            setBody({
                              ...body,
                              position_id: e.target.value
                            });
                          }}
                          className="moderation-dropdown"
                        >
                          <option selected hidden>
                            {sprintf(
                              i18n.t("moderation.select"),
                              i18n.t("moderation.position")
                            )}
                          </option>
                          {position.length > 0 &&
                            position.map((item, index: number) => (
                              <option key={index} value={item.id}>
                                {item.attributes.title}
                              </option>
                            ))}
                        </select>
                      </View>
                    ) : (
                      <View
                        style={[
                          styles.wrapPersonList,
                          {
                            width: "90%",
                            marginTop: 20,
                            alignSelf: "center"
                          }
                        ]}
                      >
                        {listEmployee.map((item, index) => (
                          <View
                            key={index}
                            style={{ width: "50%", marginBottom: 8 }}
                          >
                            <Card
                              cardStyle={{
                                backgroundColor:
                                  body.employee_id === item.id
                                    ? "#50B1B1"
                                    : "white"
                              }}
                              onPress={() =>
                                setBody({ ...body, employee_id: item.id })
                              }
                            >
                              <View
                                style={{
                                  flexDirection: "row",
                                  alignItems: "center"
                                }}
                              >
                                <Image
                                  source={
                                    (item.attributes.avatar &&
                                      item.attributes.avatar.url) ||
                                    IMAGES.avatar
                                  }
                                  style={styles.imageStyle}
                                />
                                <View style={{ marginLeft: 4, width: "100%" }}>
                                  <Text
                                    style={[
                                      styles.textStyle,
                                      body.employee_id === item.id
                                        ? { color: "#fff" }
                                        : { color: "#707070" },
                                      { fontWeight: "bold" }
                                    ]}
                                    numberOfLines={1}
                                  >
                                    {item.attributes.name}
                                  </Text>
                                  <Text
                                    style={[
                                      styles.textStyle,
                                      body.employee_id === item.id
                                        ? { color: "#fff" }
                                        : { color: "#707070" }
                                    ]}
                                    numberOfLines={1}
                                  >
                                    {item.attributes.position_name}
                                  </Text>
                                </View>
                              </View>
                            </Card>
                          </View>
                        ))}
                      </View>
                    )}
                  </View>
                ) : null}
              </View>
            ) : null}
          </View>
        ) : null}
      </View>
      <Fixed position="bottom">
        <View>
          <View
            style={{
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <TouchableOpacity
              onPress={() => {
                _handleModerateCash();
              }}
              style={styles.button}
            >
              <Text style={styles.buttonFont}>
                {i18n.t("moderation.submit")}
              </Text>
            </TouchableOpacity>
            <TouchableOpacity onPress={onCancel}>
              <Text
                style={{
                  color: "#666666",
                  fontWeight: "bold",
                  marginBottom: 20,
                  fontFamily: "Poppins"
                }}
              >
                {i18n.t("moderation.cancel")}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </Fixed>
    </View>
  );
};

export default ModerateInvoice;
